const passwordRegex = /^.{10,}$/

export const validatePassword = (password: string, passwordRepeat: string) => {
  if (password !== passwordRepeat) {
    return 'passwordsNotEqual'
  } else if (!passwordRegex.test(password)) {
    return 'passwordToShort'
  }

  return null
}
